<template>
	<component v-if="test" :is="tag" :class="cls"><slot></slot></component>
	<slot v-else></slot>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";

const props = defineProps<{
	test: boolean,
	tag: any,
	cls?: string
}>();
</script>

<style>
</style>